import { render, staticRenderFns } from "./MessageType.vue?vue&type=template&id=5e991c80&scoped=true&"
import script from "./MessageType.vue?vue&type=script&lang=js&"
export * from "./MessageType.vue?vue&type=script&lang=js&"
import style0 from "./MessageType.vue?vue&type=style&index=0&id=5e991c80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e991c80",
  null
  
)

export default component.exports